import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import fa from 'vuetify/es5/locale/fa'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
    rtl: true,
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    lang: {
        locales: { fa },
        current: 'fa'
    },
    theme: {
        // https://theme-generator.vuetifyjs.com/
        themes: {
            light: {
                primary: '#F44336',
                secondary: '#1a2638',
                "secondary-light": '#393e46',
                error: '#EA090F',
                warning: '#FFA72C',
                success: '#32BD40',
                "sub-color": '#eeeeee',
                "fax_waiting_to_send" : '#FFA72C',
                "fax_sending" : "#2196f3",
                "fax_blacklist" : '#393e46',
                "fax_failed" : '#EA090F',
                "fax_completed" : '#32BD40',
                "fax_incoming_queue" : "#FFA72C",
                "fax_receiving" : "#2196f3",
                "fax_failed_receive" : "#EA090F",
                "fax_received" : "#32BD40"
            },
            dark: {
                primary: colors.blue.lighten3,
            }
        },
        dark: localStorage.getItem('darkMode')
    }
}

export default new Vuetify(opts)